<template>
  <div class="tw-flex tw-flex-col">
    <dt
      class="tw-order-2 tw-mt-2 tw-text-lg tw-font-medium tw-leading-6 tw-text-orange-100 leading-none"
    >
      {{ stat.content }}
    </dt>
    <dd
      class="tw-order-1 tw-text-5xl tw-font-bold tw-tracking-tight tw-text-white"
    >
      {{ stat.prefix_unit }}<span>{{ statValue.value }}</span
      >{{ stat.suffix_unit }}
    </dd>
  </div>
</template>

<script>
import gsap from 'gsap'
export default {
  props: {
    stat: {
      type: Array,
      default: [],
    },
    index: {
      type: Number,
      default: [],
    },
  },
  data() {
    return {
      statValue: { value: 0 },
    }
  },
  mounted() {
    gsap.to(this.statValue, {
      duration: 3,
      value: (index) => {
        return 200
      },
      delay: this.index * 0.1,
      onUpdate: () => {
        this.statValue.value = Math.round(this.statValue.value)
      },
      ease: 'expo.out',
    })
  },
}
</script>
